export const INITIAL_VALUE = {
  checkInDate: '',
  checkOutDate: '',
  createdDate: '',
  bookingStatus: 1,
  comment: '',
  id: '',
  contactPhone: {
    id: 0,
    number: '',
  },
  managerPhone: {
    id: 0,
    number: '',
  },
  sendPhoneVerification: false,
  sendCustomerMessage: false,
  sendManagerMessage: false,
  sendSms: false,
  company: {
    iddp: '',
    id: '',
    name: '',
    contactPerson: {
      firstName: '',
      middleName: '',
      lastName: '',
      phone: {
        number: '',
      },
      email: {
        address: '',
      },
    },
  },
  orders: [],
} as { [key: string]: any };
